/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
// @ts-ignore
import { Ort } from '../models';
// @ts-ignore
import { StringDTO } from '../models';
/**
 * OrtService - axios parameter creator
 * @export
 */
export const OrtServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Liste von Land-spezifischen Orten, die dem angegebenen Suchstring passen (Größe beschränkt auf die angegebene Zahl) und liefert diese im Form von Ortsname-PLZ Kombinationen.
         * @summary Ort
         * @param {number} landId 
         * @param {string} searchParam 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredAutoCompleteMatches: async (landId: number, searchParam: string, maxResults?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'landId' is not null or undefined
            assertParamExists('getFilteredAutoCompleteMatches', 'landId', landId)
            // verify required parameter 'searchParam' is not null or undefined
            assertParamExists('getFilteredAutoCompleteMatches', 'searchParam', searchParam)
            const localVarPath = `/api/orte/name-with-plz/{landId}/autoCompleteMatches/{searchParam}`
                .replace(`{${"landId"}}`, encodeURIComponent(String(landId)))
                .replace(`{${"searchParam"}}`, encodeURIComponent(String(searchParam)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Orten, die dem angegebenen Suchstring passen (Größe beschränkt auf die angegebene Zahl)
         * @summary Ort
         * @param {string} searchParam 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrtAutoCompleteMatches: async (searchParam: string, maxResults?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchParam' is not null or undefined
            assertParamExists('getOrtAutoCompleteMatches', 'searchParam', searchParam)
            const localVarPath = `/api/orte/name-with-plz/autoCompleteMatches/{searchParam}`
                .replace(`{${"searchParam"}}`, encodeURIComponent(String(searchParam)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert einen Ort
         * @summary Ort
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrtById: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrtById', 'id', id)
            const localVarPath = `/api/orte/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Orte anhand der Suchkriterien
         * @summary Ortsuche
         * @param {string} [ortsname] ortsname
         * @param {string} [plz] plz
         * @param {number} [landId] Land ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrte: async (ortsname?: string, plz?: string, landId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/orte/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ortsname !== undefined) {
                localVarQueryParameter['ortsname'] = ortsname;
            }

            if (plz !== undefined) {
                localVarQueryParameter['plz'] = plz;
            }

            if (landId !== undefined) {
                localVarQueryParameter['landId'] = landId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrtService - functional programming interface
 * @export
 */
export const OrtServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrtServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Liste von Land-spezifischen Orten, die dem angegebenen Suchstring passen (Größe beschränkt auf die angegebene Zahl) und liefert diese im Form von Ortsname-PLZ Kombinationen.
         * @summary Ort
         * @param {number} landId 
         * @param {string} searchParam 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilteredAutoCompleteMatches(landId: number, searchParam: string, maxResults?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StringDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilteredAutoCompleteMatches(landId, searchParam, maxResults, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Orten, die dem angegebenen Suchstring passen (Größe beschränkt auf die angegebene Zahl)
         * @summary Ort
         * @param {string} searchParam 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrtAutoCompleteMatches(searchParam: string, maxResults?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StringDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrtAutoCompleteMatches(searchParam, maxResults, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert einen Ort
         * @summary Ort
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrtById(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ort>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrtById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Orte anhand der Suchkriterien
         * @summary Ortsuche
         * @param {string} [ortsname] ortsname
         * @param {string} [plz] plz
         * @param {number} [landId] Land ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchOrte(ortsname?: string, plz?: string, landId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Ort>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchOrte(ortsname, plz, landId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrtService - factory interface
 * @export
 */
export const OrtServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrtServiceFp(configuration)
    return {
        /**
         * Liefert eine Liste von Land-spezifischen Orten, die dem angegebenen Suchstring passen (Größe beschränkt auf die angegebene Zahl) und liefert diese im Form von Ortsname-PLZ Kombinationen.
         * @summary Ort
         * @param {number} landId 
         * @param {string} searchParam 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredAutoCompleteMatches(landId: number, searchParam: string, maxResults?: number, options?: any): AxiosPromise<Array<StringDTO>> {
            return localVarFp.getFilteredAutoCompleteMatches(landId, searchParam, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Orten, die dem angegebenen Suchstring passen (Größe beschränkt auf die angegebene Zahl)
         * @summary Ort
         * @param {string} searchParam 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrtAutoCompleteMatches(searchParam: string, maxResults?: number, options?: any): AxiosPromise<Array<StringDTO>> {
            return localVarFp.getOrtAutoCompleteMatches(searchParam, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert einen Ort
         * @summary Ort
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrtById(id: number, options?: any): AxiosPromise<Ort> {
            return localVarFp.getOrtById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Orte anhand der Suchkriterien
         * @summary Ortsuche
         * @param {string} [ortsname] ortsname
         * @param {string} [plz] plz
         * @param {number} [landId] Land ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrte(ortsname?: string, plz?: string, landId?: number, options?: any): AxiosPromise<Array<Ort>> {
            return localVarFp.searchOrte(ortsname, plz, landId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrtService - interface
 * @export
 * @interface OrtService
 */
export interface OrtServiceInterface {
    /**
     * Liefert eine Liste von Land-spezifischen Orten, die dem angegebenen Suchstring passen (Größe beschränkt auf die angegebene Zahl) und liefert diese im Form von Ortsname-PLZ Kombinationen.
     * @summary Ort
     * @param {number} landId 
     * @param {string} searchParam 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrtServiceInterface
     */
    getFilteredAutoCompleteMatches(landId: number, searchParam: string, maxResults?: number, options?: any): AxiosPromise<Array<StringDTO>>;

    /**
     * Liefert eine Liste von Orten, die dem angegebenen Suchstring passen (Größe beschränkt auf die angegebene Zahl)
     * @summary Ort
     * @param {string} searchParam 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrtServiceInterface
     */
    getOrtAutoCompleteMatches(searchParam: string, maxResults?: number, options?: any): AxiosPromise<Array<StringDTO>>;

    /**
     * Liefert einen Ort
     * @summary Ort
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrtServiceInterface
     */
    getOrtById(id: number, options?: any): AxiosPromise<Ort>;

    /**
     * Liefert eine Liste von Orte anhand der Suchkriterien
     * @summary Ortsuche
     * @param {string} [ortsname] ortsname
     * @param {string} [plz] plz
     * @param {number} [landId] Land ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrtServiceInterface
     */
    searchOrte(ortsname?: string, plz?: string, landId?: number, options?: any): AxiosPromise<Array<Ort>>;

}

/**
 * OrtService - object-oriented interface
 * @export
 * @class OrtService
 * @extends {BaseAPI}
 */
export class OrtService extends BaseAPI implements OrtServiceInterface {
    /**
     * Liefert eine Liste von Land-spezifischen Orten, die dem angegebenen Suchstring passen (Größe beschränkt auf die angegebene Zahl) und liefert diese im Form von Ortsname-PLZ Kombinationen.
     * @summary Ort
     * @param {number} landId 
     * @param {string} searchParam 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrtService
     */
    public getFilteredAutoCompleteMatches(landId: number, searchParam: string, maxResults?: number, options?: any) {
        return OrtServiceFp(this.configuration).getFilteredAutoCompleteMatches(landId, searchParam, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Orten, die dem angegebenen Suchstring passen (Größe beschränkt auf die angegebene Zahl)
     * @summary Ort
     * @param {string} searchParam 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrtService
     */
    public getOrtAutoCompleteMatches(searchParam: string, maxResults?: number, options?: any) {
        return OrtServiceFp(this.configuration).getOrtAutoCompleteMatches(searchParam, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert einen Ort
     * @summary Ort
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrtService
     */
    public getOrtById(id: number, options?: any) {
        return OrtServiceFp(this.configuration).getOrtById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Orte anhand der Suchkriterien
     * @summary Ortsuche
     * @param {string} [ortsname] ortsname
     * @param {string} [plz] plz
     * @param {number} [landId] Land ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrtService
     */
    public searchOrte(ortsname?: string, plz?: string, landId?: number, options?: any) {
        return OrtServiceFp(this.configuration).searchOrte(ortsname, plz, landId, options).then((request) => request(this.axios, this.basePath));
    }
}
